import script from "./TodayComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TodayComponent.vue?vue&type=script&setup=true&lang=js"

import "./TodayComponent.vue?vue&type=style&index=0&id=7c474a5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c474a5a"]])

export default __exports__